<form [formGroup]="form">
    <!--order form card-->
    <fadv-card>
        <!--order form header-->
        <fadv-card-header>
            <div class="card-header-formatting">
                <fadv-grid-row>
                    <fadv-grid-column style="padding-top: 16px; padding-bottom: 16px;">
                        <div style="text-align:center">
                            <fadv-typography type="label-large" weight="500" variant="white">
                                {{ orderHeaderVerbiage}}
                            </fadv-typography>
                            <div id="sub-header">
                                <fadv-typography id="sub-header-text" type="label-small" weight="500" variant="white">
                                    {{ orderSubHeaderVerbiage}}
                                </fadv-typography>
                            </div>
                            <!-- </fadv-tooltip> -->
                        </div>
                    </fadv-grid-column>
                </fadv-grid-row>
            </div>
        </fadv-card-header>

        <fadv-box p="large">

            <app-candidate-details [candidate]="candidate" [disableFirstName]="false" [disableLastName]="false"
                [requireDL]="requireDL" [requireMiddleName]="requireMiddleName" (notifyParentSSN)="setSSN($event)"
                (notifyParentDob)="setDob($event)" [order]="'online'">
            </app-candidate-details>

            <fadv-box mt="large">
                <app-addresscurrent [countries]="countries" [states]="states" [currentAddress]="currentAddress"
                    [counties]="counties" [selectedState]="selectedState" [selectedCounty]="selectedCounty"
                    (zipCodeChange)="handleZipCodeChange($event)">
                </app-addresscurrent>
            </fadv-box>

            <fadv-box mt="large">
                <app-employment *ngIf="employmentRequired" [loading]="loading" [formGroup]="employment" [states]="states" [previousEmployers]="previousEmployers"
                 (onCancel)="handleEmploymentCancel($event)" (onSubmit)="addPreviousEmployer()" (onRemove)="removePreviousEmployer($event)" (endDateValidator)="endDateValidator($event)" ></app-employment>
              </fadv-box>
        
            <fadv-box mt="large">
              <app-education *ngIf="educationRequired" [loading]="loading" [formGroup]="education" [states]="states" [institutions]="institutions" [levelsOfEducation]="levelsOfEducation" (onCancel)="handleEducationCancel($event)" (diplomaAwarded)="diplomaAwarded($event)" (onSubmit)="addEducation()" (onRemove)="removeEducation($event)"></app-education>
           </fadv-box>

            <fadv-grid>
                <fadv-box mv="medium">
                    <fadv-typography type="paragraph-x-small">
                        <p>
                            <strong>By selecting Next, I certify the following:</strong>
                            This request for a consumer report is for a permissible purpose under the Fair Credit
                            Reporting Act (FCRA) and as such consumer reports provided to Requestor from First Advantage
                            will not be used for any other purpose.
                            A permissible purpose under the FCRA includes for employment reasons which may include
                            hiring, promotion, assignment, and retention decisions as an employee, volunteer or an
                            independent contractor.
                        </p>
                        <p>
                            <strong>Requestor certifies the following:</strong>
                            A clear and conspicuous written disclosure has been made to this consumer, in a document
                            that consists solely of the disclosure, that a consumer report may be obtained.
                            Such disclosure has satisfied all of the requirements set forth in the FCRA and other
                            applicable state laws. Requestor has also obtained a written authorization from this
                            consumer which will be made available to First Advantage upon request.
                            Requestor further certifies that it will not use this information in violation of any equal
                            employment opportunity laws and if it decides to take action in whole or in part on the
                            information based in the report it will follow any required adverse action requirements.
                        </p>
                        <p>
                            <strong>Obtaining Information Under False Pretenses.</strong>
                            The FCRA imposes criminal penalties including a fine, up to two years in prison, or both
                            against anyone who knowingly and willfully obtains information on a consumer from a consumer
                            reporting agency under false pretenses,
                            and other penalties for anyone who obtains such consumer information without a permissible
                            purpose.
                        </p>
                        <p>
                            Don't have a signed consent? <a class="link" role="button"
                                (click)="selectOrderType('invite')">Utilize the Applicant Invite process</a> to collect
                            consent from your applicant before ordering the background screen.
                        </p>
                    </fadv-typography>
                </fadv-box>
                <fadv-grid-row>
                    <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }"
                        alignment="{{backButtonAlignment}}">
                        <fadv-box [mb]="{ md: 'medium', sm: 'medium', xs: 'medium'}">
                            <fadv-button class="online-form-button" (click)="onCancel()"
                            name="partner-online-back-button-2">Back</fadv-button>
                        </fadv-box>
                    </fadv-grid-col>
                    <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }"
                        alignment="{{nextButtonAlignment}}">
                        <fadv-button class="online-form-button" [disabled]="form.invalid" variant='primary'
                            (click)="onSubmit()" name="partner-online-next-button-2">Next</fadv-button>
                    </fadv-grid-col>
                </fadv-grid-row>

            </fadv-grid>
        </fadv-box>
    </fadv-card>
</form>